import { createContext } from 'react';

function noop() {}

export const AuthContext = createContext({
    login: noop,
    logout: noop,
    isAuthenticated: false,
    checkDone: false,
    sessionId: null,
});
